
import './App.css';
import Cube from "./Cube"
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Cube />
      </header>
    </div>
  );
}

export default App;
